/**
 * Forget the in-progress booking when the member signs out.
 *
 * The selection (date, times, bay, guest details) lives in sessionStorage so a
 * reload keeps it, which also meant it outlived a sign-out: the next member to
 * sign in on the same tab inherited it. Auth stays unaware of booking; it only
 * emits 'logout', and this subscriber does the clearing.
 *
 * Both halves are needed. The window event resets a mounted BookingProvider's
 * state (and its storage); clearAllBookingData covers sign-outs from pages where
 * no provider is mounted, whose storage would otherwise be restored on the next
 * visit to the booking flow.
 *
 * @module booking/context/resetOnLogout
 */

import { authEvents } from '~/services/auth/events';
import { clearAllBookingData } from './sessionStorage';

export function registerBookingResetOnLogout(): () => void {
  return authEvents.on('logout', () => {
    window.dispatchEvent(new Event('butter:clearBooking'));
    void clearAllBookingData();
  });
}
